import React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import BadgesManagementContainer from '../components/badges/BadgesManagementContainer';

const BadgesManagement = ({ auth: { isAuthenticated, loading } }) => {
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/auth" />;
  return <BadgesManagementContainer />;
};

const mapStateToProps = state => ({ auth: state.auth });
export default connect(mapStateToProps)(BadgesManagement);
